export const vitrin = {
  title: 'Vitrin',
  titleEN: 'Vitrin',
  description: 'Mynet.com\’da yayınlanan liste içeriklerine benzer olarak oluşturulan, temel amacı marka ve kampanya bilinirliği arttırmak olan kullanıcıya ilgi alanındaki rnlerin satış linklerini sunan etkileşimli kurgulardır.',
  descriptionEN: 'Vitrin is a page that produces content aimed at increasing product sales while introducing users to new products and enhancing brand awareness. By creating various types of content, it connects users directly with products that they need or that will benefit them.',
  tabs: [
    {
      id: 1,
      title: 'Kategori',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/f93e88fcb7deca3d13e74a449830ea7b0c91faa11fd0d805c224cf668f693708.png',
          category: 'Trendyol',
          modalTitle: 'Trendyol',
          modal: 'image'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/317bd3157e1c2fafe7c9a93d290125c7822e97682d997aae435876e9e2f20e13.png',
          modalTitle: 'Tchino',
          category: 'Tchibo',
          modal: 'image'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/adc6cecc4275681d0377f8eb6d67e58c0f22090bbccf181c33545781fd3c583e.png',
          modalTitle: 'Gratis',
          category: 'Gratis',
          modal: 'image'
        },
        {
          id: 4,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/f4f11acc3f957948bb03abbab6cd85adf0d0a842096363b1bebc031a60010ed9.png',
          modalTitle: 'THY',
          category: 'THY',
          modal: 'image'
        },
        {
          id: 5,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/3f90414ae1072688bc633c5df4fd29e86b09bbdde7dd6591af94219552f0c5a5.png',
          modalTitle: 'Philips',
          category: 'Philips',
          modal: 'image'
        }
      ]
    },
    {
      id: 2,
      title: 'Affilliate',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/d0bd7924285c3ca2026b733299da55695018d563a6dceb7ad8e69a478e9d2959.png',
          url: 'https://onedio.com/haber/bakimina-ozen-gosterenlerin-tercihi-olan-haftanin-en-cok-satilan-kozmetik-urunleri-1083601',
          category: 'Philips'
        }
      ]
    },
    {
      id: 3,
      title: 'Madde Entegrasyonu',
      sliderPerView: 1,
      width: '580px',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/ed5c0aaed8db64b48672c7a777a5b21ba60e418f97b122a1a886e153de70e34d.png',
          modalTitle: 'Madde Entegrasyonu',
          modal: 'image',
          category: 'Madde Entegrasyonu'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/d4e35b3a030c24cc434be25ac8907203f622ccbe26bfea9007a881c8e894fb0e.png',
          modalTitle: 'Foreo - Madde Entegrasyonu',
          modal: 'image',
          category: 'Foreo'
        },
      ]
    },
  ],
  egTabs: [
    {
      id: 1,
      title: 'Category',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/f93e88fcb7deca3d13e74a449830ea7b0c91faa11fd0d805c224cf668f693708.png',
          category: 'Trendyol',
          modalTitle: 'Trendyol',
          modal: 'image'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/317bd3157e1c2fafe7c9a93d290125c7822e97682d997aae435876e9e2f20e13.png',
          modalTitle: 'Tchino',
          category: 'Tchibo',
          modal: 'image'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/adc6cecc4275681d0377f8eb6d67e58c0f22090bbccf181c33545781fd3c583e.png',
          modalTitle: 'Gratis',
          category: 'Gratis',
          modal: 'image'
        },
        {
          id: 4,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/f4f11acc3f957948bb03abbab6cd85adf0d0a842096363b1bebc031a60010ed9.png',
          modalTitle: 'THY',
          category: 'THY',
          modal: 'image'
        },
        {
          id: 5,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/3f90414ae1072688bc633c5df4fd29e86b09bbdde7dd6591af94219552f0c5a5.png',
          modalTitle: 'Philips',
          category: 'Philips',
          modal: 'image'
        }
      ]
    },
    {
      id: 2,
      title: 'Affilliate',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/d0bd7924285c3ca2026b733299da55695018d563a6dceb7ad8e69a478e9d2959.png',
          url: 'https://onedio.com/haber/bakimina-ozen-gosterenlerin-tercihi-olan-haftanin-en-cok-satilan-kozmetik-urunleri-1083601',
          category: 'Philips'
        }
      ]
    },
    {
      id: 3,
      title: 'Content Integration',
      sliderPerView: 1,
      width: '580px',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/ed5c0aaed8db64b48672c7a777a5b21ba60e418f97b122a1a886e153de70e34d.png',
          modalTitle: 'Content Integration',
          modal: 'image',
          category: 'Content Integration'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/d4e35b3a030c24cc434be25ac8907203f622ccbe26bfea9007a881c8e894fb0e.png',
          modalTitle: 'Foreo - Content Integration',
          modal: 'image',
          category: 'Foreo'
        },
      ]
    },
  ],
}

